import React from 'react';
import { ITopUpSelection } from '@models/interfaces/user.interface';
import { moneyFormatter } from '@components/subscription/helper/SubscriptionHelper';

export interface TopUpSelectionProps {
  selectedId: number;
  item: ITopUpSelection;
  onSelection: (id: number) => void;
}

const TopUpSelection = (props: TopUpSelectionProps) => {
  const isChecked = props.item.subscription_topup_id == props.selectedId;
  return (
    <div
      className={'flex py-2 items-center text-primary-navyblue'}
      onClick={() => props.onSelection(props.item.subscription_topup_id)}
      data-testid={'item'}
    >
      <div
        className={
          'mr-2 w-6 h-6 rounded-full border-solid ' +
          (!isChecked
            ? 'border-neutral-notebook border-[1px]'
            : 'border-primary-apricot border-[8px]')
        }
        data-testid={'radio'}
      />
      <div className={'font-semibold'}>
        {'+' +
          props.item.genie_credit +
          ' ' +
          (props.item.genie_credit == 1 ? 'Worksheet' : 'Worksheets')}
      </div>
      <div className={'ml-auto font-bold'}>
        {moneyFormatter(
          props.item.currency_code,
          props.item.price + props.item.gst_amount,
        )}
      </div>
    </div>
  );
};

export default TopUpSelection;
